/**
 * Format milliseconds into a countdown string
 */

/**
 * Format milliseconds into "DD HH MM" format
 */
export const formatCountdown = (milliseconds: number): string => {
  if (milliseconds <= 0) return '00 00 00';

  const seconds = Math.floor(milliseconds / 1000);
  const minutes = Math.floor(seconds / 60) % 60;
  const hours = Math.floor(seconds / 3600) % 24;
  const days = Math.floor(seconds / 86400);

  const pad = (n: number) => n.toString().padStart(2, '0');

  return `${pad(days)} ${pad(hours)} ${pad(minutes)}`;
};

/**
 * Format countdown with labels (e.g., "Available in: 2D 5H 30M")
 */
export const formatCountdownWithLabels = (milliseconds: number): string => {
  if (milliseconds <= 0) return 'Available now';

  const seconds = Math.floor(milliseconds / 1000);
  const minutes = Math.floor(seconds / 60) % 60;
  const hours = Math.floor(seconds / 3600) % 24;
  const days = Math.floor(seconds / 86400);

  const parts: string[] = [];
  if (days > 0) parts.push(`${days}D`);
  if (hours > 0 || days > 0) parts.push(`${hours}H`);
  parts.push(`${minutes}M`);

  return `Available in: ${parts.join(' ')}`;
};

/**
 * Calculate time until a release date
 */
export const getTimeUntilRelease = (
  releaseDate: string | Date | undefined,
): number => {
  if (!releaseDate) return 0;
  const now = Date.now();
  const release = new Date(releaseDate).getTime();
  return Math.max(0, release - now);
};

/**
 * Check if a release date has passed
 */
export const isReleased = (releaseDate: string | Date | undefined): boolean => {
  if (!releaseDate) return true;
  return Date.now() >= new Date(releaseDate).getTime();
};

/**
 * Format countdown in compact format with leading zeros (e.g., "02D 15H 30M")
 */
export const formatCountdownCompact = (milliseconds: number): string => {
  if (milliseconds <= 0) return '00D 00H 00M';

  const seconds = Math.floor(milliseconds / 1000);
  const minutes = Math.floor(seconds / 60) % 60;
  const hours = Math.floor(seconds / 3600) % 24;
  const days = Math.floor(seconds / 86400);

  const pad = (n: number) => n.toString().padStart(2, '0');

  return `${pad(days)}D ${pad(hours)}H ${pad(minutes)}M`;
};
